import React from 'react'

const IconSun = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' fill='none'>
      <g filter='url(#filter0_d_17652_12303)'>
        <rect x='2' y='1' width='24' height='24' rx='12' fill='white' />
        <mask
          id='mask0_17652_12303'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x='6'
          y='5'
          width='17'
          height='17'
        >
          <rect x='6.5' y='5.5' width='16' height='16' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_17652_12303)'>
          <path
            d='M13.6734 7.6006V4.9668H14.7134V7.6006H13.6734ZM18.5118 9.656L17.7088 8.893L19.6118 7.0222L20.3826 7.7452L18.5118 9.656ZM19.7842 13.7114V12.6714H22.4179V13.7114H19.7842ZM13.6734 21.416V18.7898H14.7134V21.416H13.6734ZM9.89035 9.6238L7.96415 7.753L8.77495 7.0298L10.6258 8.873L9.89035 9.6238ZM19.6396 19.4206L17.7888 17.4898L18.5196 16.7668L20.415 18.6052L19.6396 19.4206ZM5.96875 13.7114V12.6714H8.60255V13.7114H5.96875ZM8.74715 19.4206L8.01175 18.6298L9.87495 16.8068L10.2288 17.156L10.5704 17.5176L8.74715 19.4206ZM14.1952 17.5914C12.9734 17.5914 11.9344 17.1638 11.078 16.3086C10.2216 15.4534 9.79335 14.4149 9.79335 13.1932C9.79335 11.9715 10.221 10.9324 11.0762 10.076C11.9314 9.2196 12.9698 8.7914 14.1916 8.7914C15.4133 8.7914 16.4524 9.219 17.3088 10.0742C18.1652 10.9294 18.5934 11.9679 18.5934 13.1896C18.5934 14.4113 18.1658 15.4504 17.3106 16.3068C16.4553 17.1632 15.4169 17.5914 14.1952 17.5914ZM14.1934 16.5514C15.1267 16.5514 15.92 16.2247 16.5733 15.5714C17.2267 14.9181 17.5534 14.1247 17.5534 13.1914C17.5534 12.2581 17.2267 11.4647 16.5733 10.8114C15.92 10.1581 15.1267 9.8314 14.1934 9.8314C13.26 9.8314 12.4667 10.1581 11.8134 10.8114C11.16 11.4647 10.8334 12.2581 10.8334 13.1914C10.8334 14.1247 11.16 14.9181 11.8134 15.5714C12.4667 16.2247 13.26 16.5514 14.1934 16.5514Z'
            fill='black'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_d_17652_12303'
          x='0.5'
          y='0.5'
          width='25.5'
          height='25'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-1' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_17652_12303' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_17652_12303'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconSun
